import { getProductsPlaceholderSubcategorySuggestions } from '@/api/generated/products-placeholder-subcategories/products-placeholder-subcategories';
import type { ListRequest, PlaceholderSubcategorySuggestion } from '@/api/generated/schemas';
import {
  defineEntityAsyncSelector,
  listRequestQueryKey,
  selectorPresets,
  toListRequest,
} from '@/shared/ui/async-selector';
import { createAsyncSelectorField } from '@/shared/forms';

/** UI ref subkategorie placeholderu ve formuláři (drží bohatý objekt kvůli chipu). */
export interface PlaceholderSubcategoryRef {
  id: string;
  name: string;
  code: string | null;
}

/**
 * Selektor subkategorií placeholderů nad `POST /api/products/placeholder-subcategories/suggestions`.
 * Kontext (typ placeholderu, druh dopravy) se předává přes `extraFilters` z volajícího formuláře
 * (`toListRequest(ctx.search, ctx.ids, ctx.extraFilters)`), backend vrací jen aktivní subkategorie.
 */
export const placeholderSubcategorySelector = defineEntityAsyncSelector<
  PlaceholderSubcategoryRef,
  PlaceholderSubcategorySuggestion,
  ListRequest
>({
  api: {
    fetch: getProductsPlaceholderSubcategorySuggestions,
    buildApiParams: (ctx) => toListRequest(ctx.search, ctx.ids, ctx.extraFilters),
    queryKey: (request) => listRequestQueryKey('venua-planner.placeholder-subcategories', request),
    mapItem: (s) => ({ id: s.id, name: s.name, code: s.code ?? null }),
  },
  key: (item) => item.id,
  objectCategory: 'PlaceholderSubcategory',
  display: {
    kind: 'nameCode',
    name: (item) => item.name,
    code: (item) => item.code,
  },
  columns: (t) =>
    selectorPresets.nameAndCode({
      name: {
        id: 'name',
        header: t('schemes.subcategorySelector.columns.name'),
        value: (item) => item.name,
        sortable: true,
      },
      code: {
        id: 'code',
        header: t('schemes.subcategorySelector.columns.code'),
        value: (item) => item.code,
        emptyDash: '—',
      },
    }),
  i18n: { namespace: 'venua-planner' },
});

export const PlaceholderSubcategorySelector = placeholderSubcategorySelector.Selector;
export const PlaceholderSubcategorySelectorField = createAsyncSelectorField(
  PlaceholderSubcategorySelector
);
